
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import Axios from "axios";
import Spinner from "../component/Spinner";

const TRANG_THAI = {
    cho_cham: { label: "Chờ chấm", cls: "text-warning" },
    da_cham: { label: "Đã chấm", cls: "text-success" },
    dang_lam: { label: "Đang làm", cls: "text-secondary" },
};

export default function BaiKiemTraCuaToi() {
    const { user } = useSelector((state) => state.auth);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let mounted = true;
        setLoading(true);
        Axios.get(URL_LIST_ALL + "learninghub_dethi_cua_toi", user.config)
            .then((res) => {
                setLoading(false);
                if (res.data.status === "success") { if (mounted) setList(res.data.data || []); }
                else console.log(res.data.message);
            })
            .catch((err) => { console.log(err); setLoading(false); });
        return () => (mounted = false);
    }, [user]);

    return (
        <AkkhorLayout idrole="dashboard">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li>Bài kiểm tra / Bài tập của tôi</li>
                </ul>
            </div>

            <div className="card height-auto mt-2">
                <div className="card-body">
                    <h3 className="mb-3">Bài kiểm tra / Bài tập của tôi</h3>
                    {loading && <div className="w-100 text-center"><Spinner /></div>}
                    {!loading && list.length === 0 && <div className="alert alert-info">Hiện chưa có bài kiểm tra / bài tập nào dành cho bạn.</div>}

                    <div className="row">
                        {list.map((d) => {
                            const tt = d.bailam_trangthai ? TRANG_THAI[d.bailam_trangthai] : null;
                            return (
                                <div className="col-12 col-sm-6 col-lg-4 mb-3" key={d.id}>
                                    <div className="wrapper border shadow rounded p-3 h-100 d-flex flex-column">
                                        <div className="d-flex justify-content-between">
                                            <span className="badge badge-light">{d.loai === 'baitap' ? 'Bài tập về nhà' : 'Bài kiểm tra'}</span>
                                            <span className="badge badge-primary">{d.so_cau} câu · {d.tong_diem}đ</span>
                                        </div>
                                        <h5 className="mt-2">{d.title}</h5>
                                        {d.course_title && <p className="text-muted mb-1"><small>Khóa học: {d.course_title}</small></p>}
                                        {d.mota && <p className="text-muted small flex-grow-1">{d.mota}</p>}

                                        {tt && <p className="mb-2"><small>Trạng thái: <span className={tt.cls}>{tt.label}</span>
                                            {d.bailam_trangthai === 'da_cham' && d.bailam_diem != null && <strong> · {d.bailam_diem}/{d.tong_diem}đ</strong>}
                                        </small></p>}

                                        <div className="mt-auto">
                                            {d.bailam_id
                                                ? <Link to={"/ket-qua-bai-lam/" + d.bailam_id} className="btn btn-sm btn-info w-100">Xem kết quả</Link>
                                                : <Link to={"/lam-bai-thi/" + d.id} className="btn btn-sm btn-success w-100">Làm bài</Link>}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </AkkhorLayout>
    );
}
